import { useEffect, useState } from 'react';
import { AnyAction } from 'redux';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _pickBy from 'lodash/pickBy';
import _identity from 'lodash/identity';
// import { NotificationItem } from 'admin-console-library';
import { useCustomDispatch } from 'core/hooks';
import { useAppSelector } from 'store';

interface Options {
  providerName?: string;
}

const useFetchListNotChangeSearchParam = (
  action?: (payload) => AnyAction,
  options?: Options,
): {
  params: Record<string, number>;
  loadList: (data: Record<string, unknown>) => void;
  list: Record<string, unknown>[];
  total: number;
  page: number;
  loading: boolean;
} => {
  const dispatch = useCustomDispatch();
  const providerName = _get(options, 'providerName', 'general');
  const { list, total, loading, page } = useAppSelector((state) => state[providerName]);
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    if (action) {
      dispatch(action(params));
    }
  }, [action, params]);

  const loadList = (data) => {
    let params = { ...data };
    if (!_has(params, 'page') || !_has(params, 'limit')) {
      params.page = data.page || 1;
      params.limit = data.limit || 10;
    }
    params = _pickBy(params, _identity);
    setParams(params);
  };

  return {
    params,
    loadList,
    list,
    total,
    loading,
    page,
  };
};

export default useFetchListNotChangeSearchParam;
